import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { VendorService } from 'src/app/services/vendor.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorBankService } from 'src/app/services/vendor-bank.service';
import { VendorBankRequest } from 'src/app/models/vendor.model';
import { AccountService } from 'src/app/services/account.service';
import { AccountOptionResponse, AccountResponse } from 'src/app/models/account.model';
import { HttpErrorResponse } from '@angular/common/http';
import { BixmlService } from 'src/app/services/bixml.service';
import { BillpayService } from 'src/app/services/billpay.service';
import { PurchasesService } from 'src/app/services/purchases.service';
import { TransferTokenService } from 'src/app/services/transfer-token.service';

@Component({
  selector: 'app-bi-transfer-transaction',
  templateUrl: './bi-transfer-transaction.component.html',
  styleUrls: ['./bi-transfer-transaction.component.scss']
})
export class BiTransferTransactionComponent {
  accounts: AccountResponse[] = [];
  filterAccounts: AccountResponse[] = [];
  filterAccountsDebit: AccountResponse[] = [];
  client = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  clients = [];
  filterClients = [];
  clientSelected = null;
  timeout = null;
  user = null;
  company = null;
  transferType: number = 0;
  selectedOwnAccount: string = null;
  selectedThirdPartyAccount: string = null;
  amount: number = null;
  description: string = '';
  vendorAccounts: VendorBankRequest[] = [];
  bankAccountNumberDebit: string = null;
  accountOptions: AccountOptionResponse = null;

  confirmModalVisible: boolean = false;
  transferPreview: any = null;
  providersInvoice = [];
  remainingAmount: number = 0;
  invoiceDetail: any = null;

  showInputCode = false;
  loadingSendCode = false;
  code2fa = '';

  constructor(
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private vendorService: VendorService,
    private vendorBankService: VendorBankService,
    private accountService: AccountService,
    private billToPayService: BillpayService,
    private bixmlService: BixmlService,
    private purchaseService: PurchasesService,
    private transferTokenService: TransferTokenService,
  ) {
    this.user = authService.getUser();
    this.company = JSON.parse(authService.getCurrentCompany());
  }

  ngOnInit(): void {
    this.getInitVendors();
    this.getBanksOwn();
    this.getAccountOptions();
  }

  getInitVendors() {
    this.vendorService.getVendors().subscribe({
      next: (response: ResponseObject) => {
        const clientsData = response.data;
        this.clients = clientsData;
        this.client.filterElements = clientsData;
        this.client.class = "fa-list";
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    });
  }

  getBanksOwn() {
    this.accountService.getAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data;
        this.filterAccounts = this.accounts;
        this.filterAccountsDebit = this.accounts.filter(account => account.bank == 1);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  getAccountOptions() {
    this.accountService.getAccountOptions().subscribe({
      next: (response: ResponseObject) => {
        this.accountOptions = response.data as AccountOptionResponse;
        console.log(this.accountOptions);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  getBanksByClient(idVendor: number) {
    this.vendorBankService.getVendorBanksByVendorId(idVendor).subscribe({
      next: (response: ResponseObject) => {
        this.vendorAccounts = response.data;
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    });
  }

  getBillsToPayWithWarehouse(idVendor: number) {
    this.billToPayService.getBillsWarehouse(idVendor).subscribe({
      next: (response: ResponseObject) => {
        this.providersInvoice = response.data.providerInvoices;
        console.log(this.providersInvoice);
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    });
  }

  selectClient(client: any, status) {
    this.clientSelected = client;
    this.getBanksByClient(client.id);
    this.getBillsToPayWithWarehouse(client.id);
  }


  writeClient() {
    clearTimeout(this.timeout);
    this.client.class = "typing";
    this.timeout = setTimeout(() => {
      this.client.class = "loading";
      this.vendorService.getProvidesByClue(this.client.value).subscribe({
        next: (response: ResponseObject) => {
          this.client.filterElements = response.data;
          if (this.client.filterElements.length == 0) {
            this.client.class = "fa-xmark";
            this.client.required = true;
          } else {
            this.client.class = "fa-filter";
          }
        }, error: (error: any) => {
          this.client.required = true;
          this.client.class = "fa-xmark";
          this.toastService.error("Error al obtener los datos del proveedor " + this.client.value);
        }
      })
    }, 500);
  }

  getBankName(idBank: number): string {
    if (!this.accountOptions || !this.accountOptions.erpBanks) return '';
    const bank = this.accountOptions.erpBanks.find(b => b.id === idBank);
    return bank ? bank.name : 'Banco desconocido';
  }

  getBankAccountTypeName(typeId: number): string {
    if (!this.accountOptions || !this.accountOptions.bankAccountTypes) return '';
    const type = this.accountOptions.bankAccountTypes.find(t => t.id === typeId);
    return type ? type.name : 'Tipo desconocido';
  }

  generateXmlTest() {
    this.toastService.success("Transferencia encolada Correctamente");
  }

  generateXml() {
    if (this.transferType === 0 && this.selectedOwnAccount === this.bankAccountNumberDebit) {
      this.toastService.error('La cuenta de débito no puede ser igual a la cuenta de crédito.');
      return;
    }

    const request = {
      description: this.description,
      amount: this.amount,
      bankAccountNumberCredit: this.transferType === 0
        ? this.selectedOwnAccount
        : this.selectedThirdPartyAccount,
      bankAccountNumberDebit: this.bankAccountNumberDebit,
      documentType: 0,
      transferType: this.transferType,
      company: this.company.companyId
    };

    let requestBill = null;
    if (this.transferType != 0) {
      requestBill = this.generateRequestBillsPayment();

      if (requestBill == null) {
        return;
      }
    }

    if (!this.code2fa) return;

    const requestCombined = {
      billPaymentsRequest: requestBill,
      xmlRequest: request,
      token: this.code2fa
    }

    this.bixmlService.sendRequestS3(requestCombined).subscribe({
      next: (response: any) => {
        this.toastService.success("Transferencia encolada Correctamente");
        this.resetForm();
      },
      error: (err) => {
        console.error('Error al generar la transacción', err);
        this.toastService.error('Error al generar la Transferencia');
      }
    });
  }

  resetForm() {
    this.transferType = 0;
    this.selectedOwnAccount = null;
    this.selectedThirdPartyAccount = null;
    this.amount = null;
    this.description = '';
    this.vendorAccounts = [];
    this.bankAccountNumberDebit = null;
    this.clientSelected = null;
    this.client = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  }

  openConfirmModal() {
    if (!this.amount || !this.description || !this.bankAccountNumberDebit) {
      this.toastService.error("Debes llenar todos los campos antes de continuar");
      return;
    }

    const debitAccount = this.accounts.find(
      acc => String(acc.accountNumber) === String(this.bankAccountNumberDebit)
    );

    let creditAccount = null;
    if (this.transferType === 0) {
      creditAccount = this.accounts.find(
        acc => String(acc.accountNumber) === String(this.selectedOwnAccount)
      );
    } else {
      creditAccount = this.vendorAccounts.find(
        acc => String(acc.accountNumber) === String(this.selectedThirdPartyAccount)
      );
    }


    this.transferPreview = {
      description: this.description,
      amount: this.amount,
      debitAccount,
      creditAccount
    };

    this.confirmModalVisible = true;
  }


  onConfirmTransfer() {
    this.confirmModalVisible = false;
    this.generateXml();
  }

  onCancelTransfer() {
    this.confirmModalVisible = false;
    this.loadingSendCode = false;
    this.showInputCode = false;
    this.code2fa = '';
  }

  updateSuggestedPayments() {
    if (!this.amount || this.amount <= 0) {
      this.providersInvoice.forEach(inv => inv.suggested = 0);
      this.remainingAmount = 0;
      return;
    }

    let remaining = this.amount;

    this.providersInvoice.forEach(inv => {
      if (remaining >= inv.balance) {
        inv.suggested = inv.balance;
        remaining -= inv.balance;
      } else {
        inv.suggested = remaining;
        remaining = 0;
      }
    });

    this.remainingAmount = remaining;
  }

  // Copiar sugerido real
  setRealFromSuggested(index: number) {
    const inv = this.providersInvoice[index];
    inv.paymentReal = inv.suggested;
    this.validateRealPayments();
  }

  // Validar que la suma de pagos reales coincida con el monto de transferencia
  validateRealPayments() {
    const totalReal = this.providersInvoice.reduce((sum, inv) => sum + (inv.paymentReal || 0), 0);

    if (totalReal > this.amount) {
      this.toastService.error("La suma de pagos reales no puede superar el monto de la transferencia.");
      return false;
    }

    // Permite que sea menor (si hay sobrante), pero marca aviso
    if (totalReal < (this.amount - this.remainingAmount)) {
      // this.toastService.warning("El total de pagos reales es menor al monto asignado a facturas (hay sobrante).");
    }

    return true;
  }

  setAllRealFromSuggested() {
    this.providersInvoice.forEach(inv => {
      inv.paymentReal = inv.suggested;
    });
    this.validateRealPayments();
  }

  sendBillsPayment() {
    if (!this.validateRealPayments()) return;

    const invoicesToPay = this.providersInvoice
      .filter(inv => inv.paymentReal && inv.paymentReal > 0)
      .map(inv => ({
        invoice: inv.id,
        amount: inv.paymentReal,
        type: 0
      }));

    // Si hay sobrante, agregarlo como anticipo
    if (this.remainingAmount > 0) {
      invoicesToPay.push({
        invoice: -2000,
        amount: this.remainingAmount,
        type: 2
      });
    }

    if (invoicesToPay.length === 0) {
      this.toastService.error("Debes ingresar al menos un pago real o tener sobrante para procesar.");
      return;
    }

    const totalReal = invoicesToPay.reduce((sum, inv) => sum + inv.amount, 0);

    if (totalReal !== this.amount) {
      this.toastService.error("La suma de pagos reales más anticipo debe coincidir exactamente con el monto de la transferencia.");
      return;
    }

    const request = {
      bankAccount: this.bankAccountNumberDebit,
      date: new Date().toISOString(),
      amount: totalReal,
      description: this.description || "Pago de facturas",
      billPayRequest: {
        invoiceList: invoicesToPay,
        provider: this.clientSelected.id
      }
    };

    console.log("Pago de facturas:", request);
    // this.billToPayService.saveRequest(request,1).subscribe({
    //   next: (response: any) => {
    //     console.log("response request saved", response)
    //     this.toastService.success("Request guardado correctamente");
    //   },
    //   error: (err) => {
    //     console.error('Error al generar la transaccion', err);
    //     this.toastService.error('Error al generar la el request');
    //   }
    // });
  }

  generateRequestBillsPayment() {
    if (!this.validateRealPayments()) return null;

    const invoicesToPay = this.providersInvoice
      .filter(inv => inv.paymentReal && inv.paymentReal > 0)
      .map(inv => ({
        invoice: inv.id,
        amount: inv.paymentReal,
        type: 0
      }));

    // Si hay sobrante, agregarlo como anticipo
    if (this.remainingAmount > 0) {
      invoicesToPay.push({
        invoice: -2000,
        amount: this.remainingAmount,
        type: 2
      });
    }

    if (invoicesToPay.length === 0) {
      this.toastService.error("Debes ingresar al menos un pago real o tener sobrante para procesar.");
      return;
    }

    const totalReal = invoicesToPay.reduce((sum, inv) => sum + inv.amount, 0);

    if (totalReal !== this.amount) {
      this.toastService.error("La suma de pagos reales más anticipo debe coincidir exactamente con el monto de la transferencia.");
      return;
    }

    const request = {
      bankAccount: this.bankAccountNumberDebit,
      date: new Date().toISOString(),
      amount: totalReal,
      description: this.description || "Pago de facturas",
      billPayRequest: {
        invoiceList: invoicesToPay,
        provider: this.clientSelected.id
      }
    };

    console.log("Pago de facturas:", request);
    return request;
    // this.billToPayService.saveRequest(request,1).subscribe({
    //   next: (response: any) => {
    //     console.log("response request saved", response)
    //     this.toastService.success("Request guardado correctamente");
    //   },
    //   error: (err) => {
    //     console.error('Error al generar la transaccion', err);
    //     this.toastService.error('Error al generar la el request');
    //   }
    // });
  }

  viewInvoiceDetail(invoice: any) {
    this.purchaseService.getDetailInvoice(invoice).subscribe({
      next: (response: ResponseObject) => {
        this.invoiceDetail = {
          ...invoice,
          detail: response.data,
          total: invoice.balance,
          dateString: new Date(invoice.documentDate).toLocaleDateString('es-GT')
        };
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el detalle de la factura");
      }
    });
  }

  closeInvoiceDetail() {
    this.invoiceDetail = null;
    this.showInputCode = false;
    this.code2fa = '';
  }

  sendRequestCode() {
    this.loadingSendCode = true;
    
    this.transferTokenService.createTokenTransfer().subscribe({
      next: (response: ResponseObject) => {
        this.showInputCode = true;
        this.loadingSendCode = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al solicitar token");
        this.loadingSendCode = false;
      }
    });
  }

  async pastClipboard() {
    try {
      this.code2fa = await navigator.clipboard.readText();
    } catch (error) {
      console.error('No se pudo leer el portapapeles', error);
      this.toastService.error('No se pudo leer el portapapeles');
    }
  }
}
